import React from 'react';
import { Link } from 'react-router-dom';

const PaymentCancelled = () => {
  return (
    <div className="min-h-screen py-24 md:py-32 px-6 md:px-12 flex items-center justify-center">
      <div className="max-w-2xl text-center">
        <div className="mb-8">
          <div className="w-24 h-24 mx-auto mb-6 rounded-full bg-amber-100 flex items-center justify-center">
            <svg className="w-12 h-12 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </div>
          <h1 className="font-heading text-4xl md:text-5xl font-normal tracking-tight text-charcoal mb-6">
            Betaling Gekanselleer
          </h1>
          <p className="font-body text-xl leading-relaxed text-muted-charcoal mb-12">
            U betaling is gekanselleer. Geen bedrag is van u rekening afgehaal nie.
            U kan terugkeer om weer te probeer wanneer u gereed is.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/purchase"
            data-testid="cta-try-again"
            className="bg-charcoal text-parchment hover:bg-charcoal/80 rounded-sm px-8 py-4 font-ui uppercase tracking-widest text-sm transition-colors duration-300"
          >
            Probeer Weer
          </Link>
          <Link
            to="/"
            data-testid="cta-home"
            className="border border-charcoal text-charcoal hover:bg-charcoal hover:text-parchment rounded-sm px-8 py-4 font-ui uppercase tracking-widest text-sm transition-colors duration-300"
          >
            Terug na Tuis
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancelled;
